import React, { useState, useEffect } from "react";
import { StatusBar } from "expo-status-bar";
import { Platform } from "react-native";

/**
 * StatusBarWrapper component that displays the status bar after a 10-second delay.
 * This is used to stop the logo jumping around as we transition between
 * the splash screen -> FakeSplash -> App.
 *
 * It's a known issue and is fixed in Expo SDK 52 https://github.com/expo/expo/issues/21036
 * This works for now. ios and web ignore this anyway.
 *
 * @returns {JSX.Element} The StatusBar component or null if not yet shown.
 */
const StatusBarWrapper = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setShow(true);
      },
      Platform.OS == "android" ? 10000 : 0
    );
    return () => clearTimeout(timer);
  }, []);

  return <>{show ? <StatusBar style="light" /> : null}</>;
};

export default StatusBarWrapper;
